import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouteService } from '../../modules/_core';

@Component({
  selector: 'app-welkom',
  templateUrl: './welkom.component.html',
  styleUrls: ['./welkom.component.css'],
})
export class WelkomComponent implements OnInit {
  constructor(private _router: Router, private _routeService: RouteService) {}

  ngOnInit() {}

  startOnClick() {
    this._router.navigate(this._routeService.getOverzichtRoute());
  }
}
